import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import { BASE_URL } from '../Config/Base';

const FoundSectionJSMain = () =>{

  useEffect(()=>{

    getEvent();
    getGalleries();

  })

   
  function getEvent() {


          
    fetch(`${BASE_URL}/FoundationMain/GetEvent`, {

      method: 'GET',

      headers: {

        "Content-type": "application/json",

        "Accept": "application/json",

        // "Authorization": "Bearer " + `${token}`,

        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

      },

      //body:JSON.stringify(data)

    }).then(response => response.json())

      .then(data => {
        console.log("Data", data)
        localStorage.setItem("paginationDataEvents", JSON.stringify(data));  
      }
      );

   
  }

  function getGalleries(){
      
      
    //console.log("Token", token)
  fetch(`${BASE_URL}/FoundationMain/GetGalleries`, {

    method: 'GET',

    headers: {

      "Content-type": "application/json",

      "Accept": "application/json",

      //"Authorization": "Bearer " + `${token}`,

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

    },

    //body:JSON.stringify(data)

  }).then(response => response.json())

    .then(data => {
      console.log("Data", data)
     // setGalleries(data)
      // setpaginatedPosts(_(data).slice(0).take(pageSize).value());
      localStorage.setItem("paginationDataGalleries", JSON.stringify(data));    
        }
    );


    
  }
           

  return (

    <div className='foundation-addmain mainimage'>

    <div className="foundation-addgrid-layout"> 
    <div className="foundation-addmain-top">
    <div className='foundation-addmain-back'>
    <Link to='/FoundSection'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
    </div> 
    <span>Journey and Stories</span>
    </div>
    </div>

    <div className='section-responsive'>
    <div className='foundation-section' id="section-menu" >

    <ul>
       
    <li><Link to="/FoundSectionET"><button className="foundation-sec-button" >Events &nbsp;&nbsp;<i className="fa-solid fa-angles-right" /></button></Link></li>
    
    <li><Link to="/FoundSectionEI"><button className="foundation-sec-button" >Event Galleries &nbsp;&nbsp;<i className="fa-solid fa-angles-right" /></button></Link></li>
    
    
    
    
    </ul>
    
    </div>
    </div>

    </div>
  )
}

export default FoundSectionJSMain
